import type { Ref } from 'vue';
import type { DxDataGrid } from 'devextreme-vue/data-grid';
import type { ContextMenuPreparingEvent } from 'devextreme/ui/data_grid';

export interface UseDataGridInteractionsOptions {
  dataGridRef: Ref<InstanceType<typeof DxDataGrid>>;
}

export const useDataGridInteractions = ({ dataGridRef }: UseDataGridInteractionsOptions) => {
  const onContextMenuPreparing = (event: ContextMenuPreparingEvent): void => {
    if (event.row && event.row.rowType === 'header' && event.items) {
      event.items.push({
        icon: 'trash',
        text: 'Delete',
        beginGroup: true,
        onItemClick: () => {
          event.component.columnOption(`name:${event.column!.name}`, 'visible', false);
        }
      });
    }
  };

  const isColumnChooserOpen = (): boolean => {
    const wrapper = document.querySelector<HTMLElement>(
      '.dx-datagrid-column-chooser-mode-select, .dx-datagrid-column-chooser-mode-drag'
    );
    return !!wrapper && window.getComputedStyle(wrapper).display !== 'none';
  };

  const showColumnChooser = () => {
    const instance = dataGridRef.value.instance;
    if (!instance) return;

    if (isColumnChooserOpen()) {
      instance.hideColumnChooser();
    } else {
      instance.showColumnChooser();
    }
  };

  return { onContextMenuPreparing, showColumnChooser };
};
